(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("AlarmsViewModel", alarmsViewModelFactory);

  /** @ngInject */
  function alarmsViewModelFactory(
    gridUtils,
    DateTime,
    facilityUtils,
    $translate
  ) {
    function AlarmsViewModel() {
      this.facilities = [];
      this.selectedFacilitySerial = "-1";
      this.paginationNumber = 0;
      this.activeAlarmsList = [];

      // GRID CONFIG
      this.alarmsData = [];
      this.alarmsOrderBy = "-timestamp";
      this.alarmsOrder = "desc";
      this.alarmsPage = 1;
      this.alarmsTotal = 0;
      this.alarmsPageSize = 10;
      this.alarmsPageOptions = [10];
      // this.selected = [];
      this.pagerTranslations = {
        page: $translate.instant("GRID_PAGER_PAGE"),
        rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
        of: $translate.instant("GRID_PAGER_PAGE_OF")
      };

      this.alarmsFrom = new Date(
        new DateTime().startOf(DateTime.units.MONTH).timestamp
      );
      this.alarmsTo = new Date(
        new DateTime().endOf(DateTime.units.DAY).timestamp
      );

      init.call(this);
    }

    AlarmsViewModel.prototype.destroy = function() {};

    AlarmsViewModel.prototype.alarmsFilterChanged = function() {
      //event handler hook
    };

    AlarmsViewModel.prototype.alarmsPaginationChanged = function(page, limit) {
      this.alarmsPage = page;
      this.alarmsPageSize = limit;
      this.alarmsFilterChanged();
    };

    AlarmsViewModel.prototype.alarmsOrderingChanged = function(order) {
      var orderQuery = getOrderObject(order);
      this.alarmsOrderBy = orderQuery.orderBy;
      this.alarmsOrder = orderQuery.order;
    };

    AlarmsViewModel.prototype.refreshMessages = function(messagesArrayJson) {
      this.alarmsData = messagesArrayJson.content;
      this.paginationNumber = messagesArrayJson.number;
      this.alarmsTotal = messagesArrayJson.totalElements;
    };

    AlarmsViewModel.prototype.refreshFacilities = function(devicesJson) {
      this.facilities = [];

      this.facilities.push({
        id: -1,
        name: "ALL_FACILITIES",
        deviceSerial: "-1"
      });

      devicesJson.forEach(function(deviceJson) {
        this.push({
          id: facilityUtils.getFacilityPoint(deviceJson).id,
          name: facilityUtils.getFacilityPoint(deviceJson).name,
          deviceSerial: deviceJson.deviceKey
        });
      }, this.facilities);
    };

    // helper function
    function getOrderObject(order) {
      var result = {
        order: "asc",
        orderBy: order
      };

      if (order.indexOf("-") > -1) {
        result.order = "desc";
        result.orderBy = order.substring(1);
      }
      return result;
    }

    return AlarmsViewModel;

    function init() {
      var gridSettings = gridUtils.getDefaultGridSettings();
      this.pagerLabel = gridSettings.translations;
    }
  }
})();
